<template>
<div class="chapter">
<div class="inner_page">
<p class="toc_entry" id="page_iii">Contents</p>
<p class="toc_entry1"><a class="calibre4" href="#/text/part0003#page_1">Preface: “God Loves You and Has a Wonderful Plan For Your Life”</a></p>
<p class="toc_entry1"><a class="calibre4" href="#/text/part0004#page_6">Introduction: Progressions</a></p>
<p class="toc_entry2"><a class="calibre4" href="#/text/part0005#page_12">P<span class="small">ART</span> I—G<span class="small">OD</span>’<span class="small">S</span> E<span class="small">SSENTIAL</span> B<span class="small">EING AND</span> E<span class="small">TERNAL</span> P<span class="small">LAN</span></a></p>
<p class="toc_entry3"><a class="calibre4" href="#/text/part0006#page_14">Day 1—The Nature and Character of God</a></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0007#page_28" title="Link target outside of Sample">Day 2—God’s Eternal Plan and Purpose<br class="calibre6"/>
For His Created Universe</span></p>
<p class="toc_entry2"><span class="calibre4" href="#/text/part0008#page_48" title="Link target outside of Sample">P<span class="small">ART</span> II—G<span class="small">OD</span> P<span class="small">LAN</span> F<span class="small">OR</span> M<span class="small">ANKIND</span></span></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0009#page_50" title="Link target outside of Sample">Day 3—God’s Plan For Mankind: General Principles and Universal Commands</span></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0010#page_69" title="Link target outside of Sample">Day 4—God’s Plan For Mankind: Specific Commands</span></p>
<p class="toc_entry4"><span class="calibre4" href="#/text/part0011#page_86" title="Link target outside of Sample">P<span class="small">ART</span> III—G<span class="small">OD</span> P<span class="small">LAN</span> F<span class="small">OR</span> Y<span class="small">OU</span></span></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0012#page_88" title="Link target outside of Sample">Day 5—God’s Revealed Will Through Scripture</span></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0013#page_96" title="Link target outside of Sample">Day 6— God’s Revealed Will Through the Holy Spirit</span></p>
<p class="toc_entry3"><span class="calibre4" href="#/text/part0014#page_108" title="Link target outside of Sample">Day 7— God’s Revealed Will Through Wise Counselors</span></p>
<p class="toc_entry5"><span class="calibre4" href="#/text/part0015#page_115" title="Link target outside of Sample">Afterword—Concluding Perspectives</span></p>
<p class="toc_entry6"><span class="calibre4" href="#/text/part0016#page_120" title="Link target outside of Sample">Devotional Prayer and Study Guide</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?3ba1cc5a